import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { TEMPLATE_SKIN_KEY } from '../../constants/default_constants'
import * as defaultConst from '../../constants/default_constants'

const DetailModal = ({ title, detail, text, hide, submit, save, button, newer, older, header }) => {
  return detail === null
    ? null
    : <Modal className={'css-template-' + localStorage.getItem(TEMPLATE_SKIN_KEY)} show backdrop='static' onHide={() => hide()}>
      <Modal.Header closeButton><Modal.Title>{title}</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className='btn-group' role='group' style={{ marginBottom: 0 }}>
          {save && <button type='button' className='btn btn-primary' onClick={() => save()}>
            <i className='glyphicon glyphicon-ok'/>&nbsp; {submit || defaultConst.TITLE_SUBMIT}
          </button>}
          <button type='button' className='btn btn-default' onClick={() => hide()}>
            <i className='glyphicon glyphicon-remove'/>&nbsp; {button || defaultConst.TITLE_CANCEL}
          </button>
        </div>
        {(newer || older) && <div className='btn-group' role='group' style={{ marginBottom: 0, marginLeft: '1em' }}>
          {(newer || older) && <button type='button' className='btn btn-info' onClick={() => newer()} disabled={!newer}>
            <i className='glyphicon glyphicon-chevron-left'/>&nbsp; {defaultConst.TITLE_NEWER}
          </button>}
          {(newer || older) && <button type='button' className='btn btn-info' onClick={() => older()} disabled={!older}>
            {defaultConst.TITLE_OLDER}&nbsp; <i className='glyphicon glyphicon-chevron-right'/>
          </button>}
        </div>}
        {header && <span style={{ float: 'right' }}>
          {Object.entries(header).map(([key, value]) => {
            return <span key={key}>
              <strong style={{ textTransform: 'capitalize', display: 'inline-block', paddingLeft: '1em' }}>{key}:</strong>
              &nbsp;
              <span>{value}</span>
            </span>
          })}
        </span>}
        <br />&nbsp;
        { detail ? <pre>{JSON.stringify(detail, null, 2)}</pre> : (text || '') }
      </Modal.Body>
      <Modal.Footer>
        <div className='btn-group' role='group'>
          {save && <button type='button' className='btn btn-primary' onClick={() => save()}>
            <i className='glyphicon glyphicon-ok'/>&nbsp; {submit || defaultConst.TITLE_SUBMIT}
          </button>}
          <button type='button' className='btn btn-default' onClick={() => hide()}>
            <i className='glyphicon glyphicon-remove'/>&nbsp; {button || defaultConst.TITLE_CANCEL}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
}

DetailModal.propTypes = {
  detail: PropTypes.array.isRequired,
  hide: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  button: PropTypes.string,
  header: PropTypes.object,
  newer: PropTypes.func,
  older: PropTypes.func,
  submit: PropTypes.string,
  text: PropTypes.string
}

export default observer(DetailModal)
